// react
import { useEffect, useState } from "react";

// formik
import { useFormik } from "formik";

// componets seplag
import RotuloSeplag from "./../../../components/RotuloSeplag/index";

// global
import {
  classNames,
  isFormFieldValid,
  getFormErrorMessage,
  printToast,
  // summaryExclusaoSucessoPadrao,
  // detailExclusaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao
} from "../../../config/global";

// components primereact
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import ModalSeplag from "./../../../components/ModalSeplag/index";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';

// service orgao
import { pesquisarAll as pesquisarAllOrgaos } from "../../../service/Orgao";

// service tipoAto
import { pesquisarAll as pesquisarAllTipoAto } from "../../../service/TipoAtoAdminstrativo";

import { Form as initForm, buscarEsferaOrgaoPeloCodigo } from '../../../service/ManterAmparoLegal'

import {
  criar as criarAmparoLegal,
  atualizar as atualizarAmparoLegal,
} from "../../../service/ManterAmparoLegal";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

const Index = ({ handleCloseModalAdicionarTipoCertidao, formEdit, showForm, setShowForm, edit, onSalvar }) => {

  const [optionsTipoAtoAdmistrativo, setOptionsTipoAtoAdmistrativo] = useState([]);
  const [optionsOrgaoOrigemAtoAdministrativo, setOptionsOrgaoOrigemAtoAdministrativo] = useState([]);
  const [formEditAmparo, setFormEditAmparo] = useState(initForm);
  const [descAto, setDescAto] = useState(null);
  const [anoAmparo, seAnoAmparo] = useState(null);
  const [siglaOrgao, setSiglaOrgao] = useState(null);

  useEffect(() => {

    if (edit) {
      setFormEditAmparo({
        ...formEdit,
        orgao: optionsOrgaoOrigemAtoAdministrativo.length > 0 ? optionsOrgaoOrigemAtoAdministrativo.filter(orgao => orgao.idenOrgao == formEdit.idenOrgao)[0] : null,
        atoAdm: optionsTipoAtoAdmistrativo.length > 0 ? optionsTipoAtoAdmistrativo.filter(ato => ato.idenTipoAto === formEdit.idenTipoAto)[0] : null,
        esfera: optionsOrgaoOrigemAtoAdministrativo.length > 0 ? optionsOrgaoOrigemAtoAdministrativo.filter(orgao => orgao.idenOrgao == formEdit.idenOrgao)[0].esferaGoverno : null,
      });

      setSiglaOrgao(formEdit.siglOrgao)
    } else {
      setFormEditAmparo({
        ...initForm
      });
    }


    formik.resetForm();

  }, [optionsTipoAtoAdmistrativo, optionsOrgaoOrigemAtoAdministrativo, edit, formEdit])

  useEffect(() => {
    pesquisarAllOrgaos().then((res) => {
      setOptionsOrgaoOrigemAtoAdministrativo(res)
    })

    pesquisarAllTipoAto().then((res2) => {
      setOptionsTipoAtoAdmistrativo(res2)
    })

    /*
    pesquisarAllOrgaos().then((res) => {

      pesquisarAllTipoAto().then((res2) => {

        setOptionsTipoAtoAdmistrativo(res2)

        pesquisarAllEsferaGoverno().then((res3) => {

          setOptionsEsferaGovernoAtoAdministrativo(res3)
          if (edit) {
            let orgao = res.filter(function (element) {
              return element.idenOrgao == formEdit.idenOrgao;
            });
            let atoAdm = res2.filter(function (element) {
              return element.idenTipoAto == formEdit.idenTipoAto;
            });
            let esfera = res3.filter(function (element) {
              return element.idenEsferaGoverno == formEdit.idenEsferaGoverno;
            });
            setFormEditAmparo({
              ...formEdit,
              orgao: orgao.length > 0 ? orgao[0] : null,
              atoAdm: atoAdm.length > 0 ? atoAdm[0] : null,
              esfera: esfera.length > 0 ? esfera[0] : null,

            });
            setDescAto(atoAdm.length > 0 ? atoAdm[0].descTipoAto : null)
            setSiglaOrgao(orgao.length > 0 ? orgao[0].siglOrgao : null)
            seAnoAmparo(formEdit.numrAnoAto)
            setOptionsOrgaoOrigemAtoAdministrativo(res)
          } else {
            let esferaEstadual = res3.filter(function (element) { return element.descEsferaGoverno == 'ESTADUAL' })
            setFormEditAmparo({
              ...formEditAmparo,
              esfera: esferaEstadual.length > 0 ? esferaEstadual[0] : null
            });
          }
        })
      });

    });*/

  }, []);


  const onFiltrarOrgaosDeOrigem = async (event) => {
    formik.handleChange(event);
    const codigoEsfera = event.value.idenEsferaGoverno;

    const orgaoEsfera = await buscarEsferaOrgaoPeloCodigo(codigoEsfera);

    setOptionsOrgaoOrigemAtoAdministrativo(orgaoEsfera);
  }

  const descAmparoLegalFormatado = () => {
    let descAmparoLegal = '';
    if (descAto) {
      descAmparoLegal = descAto + " - "
    }
    if (formik.values.numrAto) {
      descAmparoLegal = descAmparoLegal + formik.values.numrAto
    }
    if (anoAmparo) {
      if (descAmparoLegal === '') {
        descAmparoLegal = anoAmparo
      } else {
        descAmparoLegal = descAmparoLegal + " / " + anoAmparo
      }
    }
    if (siglaOrgao) {
      if (descAmparoLegal === '') {
        descAmparoLegal = siglaOrgao
      } else {
        descAmparoLegal = descAmparoLegal + " / " + siglaOrgao
      }
    }
    return descAmparoLegal
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formEditAmparo,
    validate: (data) => {
      let errors = {};
      if (!data.atoAdm) {
        errors.atoAdm = "Ato administrativo é de preenchimento obrigatório";
      }

      if (!data.esfera) {
        errors.esfera = "Esfera é de preenchimento obrigatório";
      }

      if (!data.orgao.idenOrgao) {
        errors.orgao = "Órgão é de preenchimento obrigatório";
      }
      if (!data.numrAto) {
        errors.numrAto = "Número do ato é de preenchimento obrigatório";
      }
      // if (!data.numrAnoAto) {
      //   errors.numrAnoAto = "Ano do ato é de preenchimento obrigatório";
      // }

      if (!data.dataPublicacaoAto) {
        errors.dataPublicacaoAto = " Data da publicação é de preenchimento obrigatório";
      }
      // if (!data.dataInicioVigencia) {
      //   errors.dataInicioVigencia = "Início da vigência é de preenchimento obrigatório";
      // }

      return errors;
    },
    onSubmit: async (data) => {
      let dadosCriacao = {
        ...data,
        tipoAto: {
          idenTipoAto: data.atoAdm.idenTipoAto,
          descTipoAto: data.atoAdm.descTipoAto,
        },
        orgao: {
          ...data.orgao
        },
        esferaGoverno: {
          idenEsferaGoverno: data.esfera.idenEsferaGoverno,
        },
        numrAto: data.numrAto,
        numrAnoAto: data.dataPublicacaoAto.split('/')[2],
        dataPublicacaoAto: data.dataPublicacaoAto,
        descComplementoAmparo: data.descComplementoAmparo,
        dataInicioVigencia: data.dataPublicacaoAto,
        dataTerminoVigencia: data.dataTerminoVigencia,
        statusAmparoLegal: data.statusAmparoLegal = 'ATIVO',
      }

      // let dadosAtualizacao = {
      //   idenAmparoLegal: formEdit?.idenAmparoLegal,
      //   orgao: data.orgao,
      //   tipoAto: data.atoAdm,
      //   esferaGoverno: {
      //     idenEsferaGoverno: data.esfera.idenEsferaGoverno,
      //   },
      //   numrAto: data.numrAto,
      //   numrAnoAto: data.dataPublicacaoAto.split('/')[2],
      //   dataPublicacaoAto: data.dataPublicacaoAto,
      //   descComplementoAmparo: data.descComplementoAmparo,
      //   dataInicioVigencia: data.dataPublicacaoAto,
      //   dataTerminoVigencia: data.dataTerminoVigencia,
      //   statusAmparoLegal: data.statusAmparoLegal,
      //   descAmparoLegal: data.descAmparoLegal
      // }




      if (edit) {
        await atualizarAmparoLegal(dadosCriacao.idenAmparoLegal, dadosCriacao).then((res) => {

          let summary;
          let detail;

          if (res.type === "INS") {
            summary = summaryCriacaoSucessoPadrao;
            detail = detailCriacaoSucessoPadrao;
          } else {
            summary = summaryAlteracaoSucessoPadrao;
            detail = detailAlteracaoSucessoPadrao;
          }
          printToast({ summary, detail });
          setShowForm(false);
          onSalvar && onSalvar()
        });

        setShowForm(false);
      } else {
        await criarAmparoLegal(dadosCriacao).then((res) => {
          onSalvar && onSalvar()

          let summary;
          let detail;

          if (res.type === "INS") {
            summary = summaryCriacaoSucessoPadrao;
            detail = detailCriacaoSucessoPadrao;
          } else {
            summary = summaryAlteracaoSucessoPadrao;
            detail = detailAlteracaoSucessoPadrao;
          }
          printToast({ summary, detail });
          setShowForm(false);
        });
      }

    }
  });

  // fechar modal
  function handlerHide() {
    formik.resetForm();
    setShowForm(false);
  }

  // Selecionar órgão
  function handleChangeOrgao(e) {
    formik.handleChange(e); 
    setSiglaOrgao(e.value.siglOrgao);
    if(edit) {
      formik.setFieldValue("descEsferaGoverno", e.value.esferaGoverno.descEsferaGoverno);
    }
    formik.setFieldValue("esfera", e.value.esferaGoverno)
  }


  return (
    <ModalSeplag
      titulo={"Amparo Legal"}
      visible={showForm}
      type="NONE"
      edit={edit}
      fechar={handlerHide}
      onClick={handlerHide}
    // tamanho="70vw"
    >
      <form onSubmit={formik.handleSubmit} >
        <div className="p-grid">

          <RotuloSeplag nome="Tipo Ato" obrigatorio cols="12 3">
            <Dropdown
              filter
              id="atoAdm"
              name="atoAdm"
              optionLabel="descTipoAto"
              //optionValue='idenTipoAto'
              options={optionsTipoAtoAdmistrativo}
              value={formik.values.atoAdm}
              onChange={(e) => { formik.handleChange(e); setDescAto(e.value.descTipoAto); }}
              placeholder="Selecione..."
              className={classNames({ "p-invalid": isFormFieldValid("atoAdm", formik) })} />
            {getFormErrorMessage("atoAdm", formik)}
          </RotuloSeplag>

          <RotuloSeplag nome="Nº Ato" cols="12 3" obrigatorio>
            <InputText
              id="numrAto"
              name="numrAto"
              value={formik.values.numrAto}
              className={classNames({ "p-invalid": isFormFieldValid("numrAto", formik) })}
              onChange={(e) => formik.handleChange(e)}
            />
            {getFormErrorMessage("numrAto", formik)}
          </RotuloSeplag>

          <RotuloSeplag nome="Data Publicação" cols="12 3" obrigatorio>
            <InputMask
              id="dataPublicacaoAto"
              mask="99/99/9999"
              slotChar="mm/dd/yyyy"
              value={formik.values.dataPublicacaoAto}
              onChange={(e) => formik.handleChange(e)}
              className={classNames({ "p-invalid": isFormFieldValid("dataPublicacaoAto", formik) })}
            />
            {getFormErrorMessage("dataPublicacaoAto", formik)}
          </RotuloSeplag>


          <RotuloSeplag nome="Órgão de origem" obrigatorio cols="12 3">
            <Dropdown
              filter
              id="orgao"
              name="orgao"
              optionLabel="descOrgao"
              options={optionsOrgaoOrigemAtoAdministrativo}
              value={formik.values.orgao}
              onChange={(e) => { handleChangeOrgao(e) }}
              placeholder="Selecione..."
              className={classNames({ "p-invalid": isFormFieldValid("orgao", formik) })} />
            {getFormErrorMessage("orgao", formik)}
          </RotuloSeplag>


          {/* <RotuloSeplag nome="Ano Ato" cols="12 4" obrigatorio>
            <InputNumber
              useGrouping={false}
              id="numrAnoAto"
              value={formik.values.numrAnoAto}
              className={classNames({ "p-invalid": isFormFieldValid("numrAnoAto", formik) })}
              onValueChange={(e) => { formik.handleChange(e); seAnoAmparo(e.value) }}
            />
            {getFormErrorMessage("numrAnoAto", formik)}
          </RotuloSeplag> */}

          {/* <RotuloSeplag nome="Data Início da Vigência do Ato" cols="12 4" obrigatorio>
            <InputMask
              id="dataInicioVigencia"
              mask="99/99/9999"
              slotChar="mm/dd/yyyy"
              value={formik.values.dataInicioVigencia}
              onChange={(e) => formik.handleChange(e)}
              className={classNames({ "p-invalid": isFormFieldValid("dataInicioVigencia", formik) })}
            />
            {getFormErrorMessage("dataInicioVigencia", formik)}
          </RotuloSeplag>

          <RotuloSeplag nome="Data Término Ato" cols="12 4">
            <InputMask
              id="dataTerminoVigencia"
              mask="99/99/9999"
              slotChar="mm/dd/yyyy"
              value={formik.values.dataTerminoVigencia}
              onChange={(e) => formik.handleChange(e)}
              className={classNames({ "p-invalid": isFormFieldValid("dataTerminoVigencia", formik) })}
            />

          </RotuloSeplag> */}

          <RotuloSeplag nome="Esfera" cols="12 3">
            <InputText
              id="esfera"
              name="esfera"
              value={edit ? formik.values.descEsferaGoverno : formik.values.esfera?.descEsferaGoverno}
              placeholder="Selecione um órgão..."
              disabled={true}/>
          </RotuloSeplag>


          <RotuloSeplag nome="Complemento" cols="12">
            <InputTextarea
              id="descComplementoAmparo"
              name="descComplementoAmparo"
              rows={5} cols={30}
              value={formik.values.descComplementoAmparo}
              onChange={(e) => formik.handleChange(e)}
              className={classNames({ "p-invalid": isFormFieldValid("descComplementoAmparo", formik) })}
            />
            {getFormErrorMessage("descComplementoAmparo", formik)}
          </RotuloSeplag>

          {edit && (
            <RotuloSeplag nome="Amparo Legal" cols="12">
              <label className="p-inputtext p-component p-filled">{descAmparoLegalFormatado()}</label>
            </RotuloSeplag>
          )}
        </div>

        <div className="p-grid" style={{ marginTop: '20px' }}>
          <div className="p-col-12 p-md-3">
            <Button
              label={edit ? 'Editar' : "Enviar"}
              icon={edit ? "pi pi-pencil" : "pi pi-check"}
              autoFocus
              className="p-button-raised margin-app-entre-button"
              type="submit"
            />
          </div>
          <div className="p-col-12 p-md-3">
            <Button
              type='button'
              label="Cancelar"
              icon="pi pi-times"
              onClick={handlerHide}
              className="p-button-outlined p-button-danger p-mb-1"
            />
          </div>
        </div>
      </form>
    </ModalSeplag>
  );
};

export default Index;
